import { SpotDataButton, SpotDataButtonStyle } from "@swivl-mono/types";
import { Button, ButtonColor, Checkbox, Input, Select } from "@swivl-mono/ui";

interface Props {
  buttons: SpotDataButton[];
  selectedButtonId: string;
  setButtons(data: SpotDataButton[]): void;
}

export function SpotButtonControls(props: Props) {
  const button = props.buttons.find((button) => button.id === props.selectedButtonId);
  if (!button) {
    return <div></div>;
  }

  const onSet = (value: any, name: string) => {
    let buttons = props.buttons.map((b) => {
      if (b.id === button.id) {
        if (name === "style") {
          return { ...b, style: value ? SpotDataButtonStyle.ACCENT : SpotDataButtonStyle.PRIMARY };
        }

        return { ...b, [name]: value };
      }
      return b;
    });
    props.setButtons(buttons);
  };

  return (
    <div className="flex flex-col gap-2 p-5">
      <div className="text-lg font-bold">Edit Button</div>
      <Input label="Icon" value={button.icon} onChange={(e) => onSet(e.target.value, "icon")} />
      <Input label="Title" value={button.title} onChange={(e) => onSet(e.target.value, "title")} />
      <Input label="Link" value={button.href} onChange={(e) => onSet(e.target.value, "href")} />

      <Select
        label="Target"
        options={[
          { label: "Same Window", value: "_self" },
          { label: "New Window", value: "_blank" }
        ]}
        selectedValues={[button.target || "_self"]}
        onChange={(values) => onSet(values[0] || "_self", "target")}
      />

      <Checkbox
        checked={button.style === SpotDataButtonStyle.ACCENT}
        name="style"
        onCheckedChange={(value) => onSet(value, "style")}
        label="Use Accent Color"
      />

      <Button
        color={ButtonColor.BLACK}
        className="mt-5"
        onClick={() => {
          if (!confirm("Are you sure you want to delete this button?")) {
            return;
          }
          let buttons = props.buttons.filter((b) => b.id !== button.id);
          props.setButtons(buttons);
        }}
      >
        Delete Button
      </Button>
    </div>
  );
}
